import { BASE_URL } from "../BaseUrl.js";
import axios from "axios";

axios.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("babiSolde_api");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      config.headers.Authorization = null;
    }

    return config;
  },
  function (error) {
    console.log("AN ERROR REQUEST", error);
  }
);

export const ListDesAdmims = async (page, size, param) => {
  return await axios.get(
    `${BASE_URL}/auth/allAdmins?page=${page}&size=${size}&param=${param}`,
    {}
  );

 
};

export const recupererListeCompleteAdmins = async () => {
  return await axios.get(`${BASE_URL}/auth/all`), {};
};

export const enregistrerAdmin = async (data) => {
  return await axios.post(`${BASE_URL}/auth/signup`, data);
};



export const supprminerAdmin = async (idAdmin) => {
    return await axios.delete(`${BASE_URL}/auth/${idAdmin}`, {})
};

// export const desactivUserById = async (idAdmin) => {
//   return await axios.put(BASE_URL(`utilisateur/desactive/${idAdmin}`), {});
// };

export const udpdateAdnim = async (idAdmin, data) => {
  return await axios.put(`${BASE_URL}/auth/${idAdmin}`, data);
};
